// extracted by mini-css-extract-plugin
module.exports = {"root":"NatRulesTableActions_root__31OMT","action":"NatRulesTableActions_action__joDjI","linkAction":"NatRulesTableActions_linkAction__25B4Q"};